import React, { createContext } from "react";
import ENVIRONMENT_VAR from "../../../model/const/env/env.const";
import { APIProvider } from "@vis.gl/react-google-maps";

interface MxMapContextProps {
  children: React.ReactNode;
}
interface MxMapContextReturn { }

const MxMapContext = createContext<MxMapContextReturn>({} as MxMapContextReturn);

export const MxMapProvider = (props: MxMapContextProps) => {
  return (
    <MxMapContext.Provider value={{}}>
      <APIProvider
        apiKey={ENVIRONMENT_VAR.MAP_KEY}
        language="es-419"
        region="do"
        libraries={['places', 'geometry', 'drawing']}
      >
        {props.children}
      </APIProvider>
    </MxMapContext.Provider>
  );
};
